import { Cookies } from "./cookies";
export class Notifications {
    static error(text, title = "Error") {
        PNotify.alert({
            title,
            text,
            type: "error",
        });
    }
    static success(text, title = "") {
        PNotify.alert({
            title,
            text,
            type: "success",
        });
    }
    static errorCookie(text, title = "Error") {
        const json = JSON.stringify({ type: "error", title, message: text });
        Cookies.set("message", json, 1);
    }
    static successCookie(text, title = "") {
        const json = JSON.stringify({
            type: "success",
            title,
            message: text,
        });
        Cookies.set("message", json, 1);
    }
    static doCookieNotification() {
        const cookie = Cookies.get("message");
        if (!cookie) {
            return;
        }
        Cookies.delete("message");
        const json = JSON.parse(cookie);
        if (json) {
            PNotify.alert({
                title: json.title,
                text: json.message,
                type: json.type,
            });
        }
    }
    static confirm(text, onOk, onCancel = undefined) {
        PNotify.notice({
            title: "",
            text,
            icon: "fas fa-question-circle",
            hide: false,
            stack: {
                dir1: "down",
                modal: true,
                firstpos1: 25,
            },
            modules: {
                Confirm: {
                    confirm: true,
                    buttons: [
                        {
                            text: "Sí",
                            textTrusted: false,
                            addClass: "",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                notice.close();
                                onOk();
                            },
                        },
                        {
                            text: "No",
                            textTrusted: false,
                            addClass: "",
                            click: (notice) => {
                                notice.close();
                                if (onCancel !== undefined) {
                                    onCancel();
                                }
                            },
                        },
                    ],
                },
                Buttons: {
                    closer: false,
                    sticker: false,
                },
                History: {
                    history: false,
                },
            },
        });
    }
}
